<template>
  <div v-if="showStaff">
    <div class="authenticate-mask" @click="$emit('close')" />
    <div class="authenticate-staff-detail">
      <div class="staff-detail-content">
        <div class="staff-org ">
          <h3>机构人员</h3>
          <span>Institutional staff</span>
          <div class="sepline"></div>
          <p>执业证号</p>
          <p class="number">{{ currentstaff.no }}</p>
          <span class="copyright">
            云南省公共法律服务平台
          </span>
        </div>
        <div class="staff-intro ">
          <div class="staff-person">
            <div class="staff-person__photo">
              <img :src="currentstaff.photo || '/wstatic/img/icon/useravater.png'" alt="">
            </div>
            <div class="staff-person__name">
              <h3>{{ currentstaff.name }}</h3>
              <span>{{ currentstaff.org_name }}</span>
            </div>

          </div>
          <div class="staff-info">

            <div class="staff-info__row " v-if="orgtype==1">
              <div class="staff-info__title">技术职称：</div>
              <div class="staff-info__role">{{ currentstaff.title }} </div>
            </div>
            <div class="staff-info__row " v-if="orgtype==2">
              <div class="staff-info__title">所属地区：</div>
              <div class="staff-info__role">{{ currentstaff.area_name }} </div>
            </div>
            <div class="block lg:hidden">
              <div class="staff-info__row   ">
                <div class="staff-info__title">执业证号：</div>
                <div class="staff-info__role">{{ currentstaff.no }} </div>
              </div>
            </div>
            <div class="staff-info__row " v-if="orgtype==2">
              <div class="staff-info__title">首次担任调解员年份：</div>
              <div class="staff-info__role"> {{ currentstaff.scdrtjynf || '-'                }} </div>
            </div>
            <div class="staff-info__row " v-if="orgtype==2">
              <div class="staff-info__title">简介：</div>
              <div class="staff-info__role"> {{ currentstaff.desc || '-'}} </div>
            </div>
            <div class="staff-info__row " v-if="orgtype==1">
              <div class="staff-info__title">行业资格：</div>
              <div class="staff-info__role">{{ currentstaff.qualification }}</div>
            </div>
            <div class="staff-info__row " v-if="orgtype==1">
              <div class="staff-info__title">执业类别：</div>
              <div class="staff-info__role staff-info__type">
                {{ currentstaff.industry_type }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <img src="https://qiniu.laway.cn/yn/2020/11/10/e823e0e822f711eb8cd1b4055d0b07be.png" alt="" class="staff-detail__close" @click="$emit('close')">
    </div>
  </div>
</template>
<script>
import { orgTypeName, residence, disputeList } from '@/datas/js/config.js'

export default {
  data () {
    return {
      orgTypeName
    }
  },
  props: ['currentstaff', 'showStaff', 'orgtype'],
}
</script>
<style lang="stylus" scoped>
.authenticate-mask
  background rgba(0, 0, 0, 0.5)
  position fixed
  top 0
  right 0
  left 0
  bottom 0
  z-index 10000
.authenticate-staff-detail
  z-index 10001
  position fixed
  top 20%
  left 50%
  transform translateX(-50%)
  width 900px
  max-width 90% !important
  .staff-detail-content
    display flex
    height 100%
    min-height 480px
    max-height 600px
    overflow hidden
  .staff-org
    position relative
    width 340px
    flex-shrink 0
    background #425db2
    padding 59px 0 30px 40px
    box-sizing border-box
    h3
      font-size 30px
      color #ffffff
      margin-bottom 15px
    span
      font-size 16px
      margin-top 15px
      color #ffffff
    .sepline
      margin-top 40px
      width 36px
      height 4px
      background #5976d2
    p
      margin-top 50px
      color #ffffff
      font-size 16px
      margin-bottom 20px
    p.number
      font-size 24px
      margin-top 19px
    span.copyright
      font-size 12px
      color #96acf2
      position absolute
      bottom 31px
      left 40px
  .staff-intro
    overflow-y auto
    overflow-x hidden
    width 600px
    padding 54px 40px
    background #ffffff
    .staff-person
      position relative
      width 500px
      height 175px
      border-bottom 1px solid #e5e5e5
    .staff-person__photo
      width 100px
      height 135px
      overflow hidden
      display flex
      justify-content center
      align-items center
      background #f3f3f3
      float left
      margin-right 30px
      text-align center
      line-height 135px
      img
        width 100%
        height 100%
        object-fit cover
    .staff-person__name
      padding-top 26px
      h3
        font-size 24px
        color #333
        margin-bottom 20px
      span
        font-size 14px
        color #999
    a.correct
      display block
      width 80px
      height 34px
      border 1px solid #e5e5e5
      position absolute
      text-align center
      line-height 34px
      right 0
      color #333
      top 76px
  .staff-info
    padding-top 40px
    .staff-info__row
      display flex
      line-height 1.6
    .staff-info__title
      font-size 16px
      color #666666
      min-width 56px
      flex-shrink 0
    .staff-info__role
      font-size 16px
      color #333333
      &.staff-info__type
        width 370px
  .staff-detail__close
    position absolute
    top 18px
    right 18px
    cursor pointer
</style>